const MyEvent = function() {
  let winW = $(window).width();
  let winH = $(window).height();
  let oldWinW = winW;
  let oldWinH = winH;
  let mediaQuery = {
    current: getSize(),
    old: getSize(),
    count: 1
  };

  $(document).ready(function() {
    $(window).triggerHandler('my_ready', mediaQuery);
  });
  $(window).on('load', function() {
    $(window).triggerHandler('my_load', mediaQuery);
  });

  $(window).on('orientationchange', function() {
    $(window).triggerHandler('my_orientationchange', mediaQuery);
  });

  $(window).on('resize', function() {
    winW = $(window).width();
    winH = $(window).height();

    if (winW !== oldWinW) {
      mediaQuery.current = getSize();
    }

    if (mediaQuery.current === mediaQuery.old) {
      // リサイズ時のカスタムイベント
      $(window).triggerHandler('my_resize', mediaQuery);

      if (winW !== oldWinW) {
        // 横幅が変わった時のカスタムイベント
        $(window).triggerHandler('my_resizeW', mediaQuery);
      }
      if (winH !== oldWinH) {
        // 縦幅が変わった時のカスタムイベント
        $(window).triggerHandler('my_resizeH', mediaQuery);
      }
    } else if (mediaQuery.current !== mediaQuery.old) {
      // 表示が切り替わった回数を保存（初回だけ処理を実行したい時用）
      mediaQuery.count++;
      // 表示が切り替わった時のカスタムイベント
      $(window).triggerHandler('my_change', mediaQuery);
    }

    mediaQuery.old = mediaQuery.current;
    oldWinW = winW;
    oldWinH = winH;
  });

  $(window).on('scroll', function() {
    $(window).triggerHandler('my_scroll', mediaQuery);
  });

  function getMediaQuery() {
    return mediaQuery;
  }
  function getSize() {
    // メディアクエリを取得（※css側でbody:beforeのcontentを指定しておくこと）
    let _mediaQuery = 'lg';
    if (window.getComputedStyle) {
      _mediaQuery = window
        .getComputedStyle(document.body, '::before')
        .getPropertyValue('content')
        .replace(/"/g, '');
    }
    return _mediaQuery;
  }

  return {
    getMediaQuery: getMediaQuery
  }
};

export default MyEvent;
